import * as constants from './constants';
import { apiLoginOut } from '../../../config/index';

export const loginOut = () => {
	return (dispatch) => {
		apiLoginOut({}).then(response => {
		}).catch(error => {
		  console.log(error)
		})
		localStorage.removeItem('lsisLogin');
		localStorage.removeItem('userObj');
		localStorage.removeItem('userPassTime');
		localStorage.removeItem('freeVideoArrls');
		localStorage.removeItem('freeVideoNumls');
		localStorage.removeItem("lastCreateTime");
		localStorage.removeItem("lastStudyTime");
		dispatch(changeLoginState(false));
	}
}

export const changeLoginState = (isLogin) => ({
	type: constants.CHANGE_LOGIN_STATE,
	isLogin
})